export default __webpack_public_path__ + "b267dba50810a97641e9c9b4af97b98b.png";